import * as React from 'react';
import type { SVGProps } from 'react';
const IconQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconQuote"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 9v4l-.005.2A4 4 0 0 1 13 17v-2a2 2 0 0 0 2-2h-2V9zM7 13V9h4v4l-.005.2A4 4 0 0 1 7 17v-2a2 2 0 0 0 2-2z"
    />
  </svg>
);
export default IconQuote;
